export default {"src":"/_next/static/media/faqssvg1.41c6db62.svg","height":57,"width":70,"blurWidth":0,"blurHeight":0};